import dayjs from "dayjs";
import { Status } from "../../../../../../utils/enums";
import { activityListToUser } from "../types/activity";

export const activityList:activityListToUser = [
    {
        id: '1',
        closeStore: 'Uniad - 23',
        endDate: dayjs().format('DD/MM/YYYY'),
        initDate: dayjs().format('DD/MM/YYYY'),
        status: Status.ACTIVE,
        storeAndId: 'Unidad - 23',
        title: 'Reunion ejemplo titulo descriptiovo',
        type: 'Tipos',
        reportUrl: ''
    },
    {
        id: '2',
        closeStore: 'Uniad - 23',
        endDate: dayjs().format('DD/MM/YYYY'),
        initDate: dayjs().format('DD/MM/YYYY'),
        status: Status.ACTIVE,
        storeAndId: 'Unidad - 23',
        title: 'Reunion ejemplo titulo descriptiovo',
        type: 'Tipos',
        isForcedClosure: true,
        reportUrl: ''
    },
]